export default {
  form_header: {
    tncli: 0,
    tnosal: '',
    tnomc: '',
    tclang: '',
    tcdev: '',
    tsiret: '',
    ttvacee: '',
    tweb: '',
    tcdiv: '',
    tcsdiv: '',
    tadr1l: '',
    tadr2l: '',
    tadr3l: '',
    tcpostl: '',
    tvillel: '',
    tcpaysl: '',
    tadr1f: '',
    tadr2f: '',
    tadr3f: '',
    tcpostf: '',
    tvillef: '',
    tcpaysf: '',
    tccom: '',
    tca: '',
    tnb_emp: '',
    tlieuprod: '',
    taut_four: '',
    ttop_grat: 0,
    telectro: 0,
    tcom: '',
    ttop_ac: 0,
    ttop_adv: 0,
    ttop_cda: 0,
    ttop_rdv: 0,
    tcprovl: '',
    tcprovf: '',
  },
  form_contact: [],
  form_typology: [],
  form_card: [],
  form_sample: [],
  form_attachment: [],
  form_special_request: {
    tmod: "",
    topt: "",
    ttail1: "",
    ttail2: "",
    tcol: 0,
    tmarq: "",
    tqte: 0,
    ttop_grat: 0,
    telectro: 0,
    tgenc: "",
    tds: "",
    tmailds: ""
  }
};